module.exports = __webpack_public_path__ + "img/shape4.9116496c.png";